import request from "../request";

export default {
  getRecursos: () => {
    return request.get("recurso");
  },

  addRecurso: (data) => {
    return request.post("recurso", data);
  },
  updateRecurso: (data) => {
    return request.put("recurso", data);
  },
  deleteRecurso: (data) => {
    return request.delete(`recurso/${data.ID_RECURSO}`);
  },
  updateRecursoEstado: (data) => {
    return request.put("recurso_estado", data);
  },
  getDispositivos(idRecurso, dateInit) {
    return request.get(`recurso/getDispositivos/${idRecurso}`, {
      params: { fechaReferencia: dateInit },
    });
  },

  getHistoricoRecursoDespacho(idRecurso) {
    return request.get(`recurso/getHistoricoRecursoDespacho/${idRecurso}`);
  },

  getTrackRecurso(idDispositivo, idRecurso, timeBack) {
    return request.post("recurso_posicion/track", {
      idDispositivo,
      idRecurso,
      timeBack,
    });
  },
  getTrackFechasRecurso(data) {
    return request.post("medio_posicion/track_fechas", data);
  },
  getTrackFechasInPolygon: (data) => {
    return request.post("recursos_posicion_polygon", data);
  },
  getMedioPersonal: (params) => {
    return request.get("medio_personal", { params });
  },
  // Expected array en data
  setMedioPersonal: (data) => {
    return request.post("medio_personal", data);
  },
  deleteMedioPersonal: (data) => {
    return request.delete(`medio_personal/${data}`);
  },
  getTurnos: () => {
    return request.get("turno");
  },
  setTurno: (data) => {
    return request.post("turno", data);
  },
  updateTurno: (data) => {
    return request.put(`turno/${data.ID_TURNO}`, data);
  },
  getEstadosRecurso: () => {
    return request.get("recurso_estado");
  },
  getRecursoEstadoTipos() {
    return request.get("recurso_sector_estado_tipo");
  },
  getEstadosAcciones() {
    return request.get("recurso_sector_estado_tipo_accion");
  },
};
